import { h } from 'preact';
import { isPlaceholder } from 'utils/data';
import MovieSidebar from 'components/editor/movies/movieSidebar/movieSidebar.js';
import s from 'components/editor/movies/movieSidebar/movieSidebarFocus.sss';

export default class FocusMovieSidebar extends MovieSidebar {
	s = s;

	getMovieStatuses(movie = this.state.movieData) {
		if (isPlaceholder(movie)) return [];
		return super.getMovieStatuses(movie);
	}

	renderSubHeading() {
		const movie = this.state.movieData;
		const movieStatus = this.getMovieStatuses(movie);
			
		return (
			<div class={s.subHeading}>
				{this.renderPageStatus()}
				<div class={s.movieStatus}>
					{movieStatus.map((status) => <span>{status}</span>)}
				</div>
			</div>
		);
	}
}